const _ = require('lodash');

module.exports = function ($timeout) {
    let timeouts;

    function SharedTimeoutService() {
        timeouts = {};
    }

    function createPromise(name, functions, delay, shouldApply) {
        return $timeout(function () {
            _.forEach(functions, function (fn) { fn(); });

            delete timeouts[name];
        }, delay, shouldApply);
    }

    SharedTimeoutService.prototype.addTimeout = function (name, fn, delay, shouldApply) {
        if (name in timeouts) {
            const existingTimeout = timeouts[name];
            $timeout.cancel(existingTimeout.promise);

            existingTimeout.functions.push(fn);

            existingTimeout.promise = createPromise(name, existingTimeout.functions, delay, shouldApply);

        } else {
            const newTimeout = {
                functions: [fn]
            };
            newTimeout.promise = createPromise(name, newTimeout.functions, delay, shouldApply);

            timeouts[name] = newTimeout;
        }
    };

    return new SharedTimeoutService();
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/shared-timeout/shared-timeout.js
 **/